module.exports = __webpack_public_path__ + "static/media/logo_universite_le_havre.0349e3ab.jpg";